export default __webpack_public_path__ + "static/media/onboarding_background.adabd641.png";